import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
          {contactData.title}
        </h2>
        <p className="text-sm text-foreground-500 mb-2">
          {contactData.subtitle}
        </p>
        <p className="text-sm text-foreground-600 leading-relaxed mb-10 max-w-xl mx-auto">
          {contactData.description}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-lg p-6">
            <div className="w-12 h-12 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center text-xl mx-auto mb-3">
              <i className="ri-mail-line"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">电子邮箱</p>
            <p className="text-sm font-medium text-foreground-900 break-all">
              {contactData.email}
            </p>
          </div>
          <div className="bg-background-100 rounded-lg p-6">
            <div className="w-12 h-12 rounded-full bg-accent-50 text-accent-500 flex items-center justify-center text-xl mx-auto mb-3">
              <i className="ri-wechat-line"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">微信公众号</p>
            <p className="text-sm font-medium text-foreground-900">
              {contactData.wechat}
            </p>
          </div>
          <div className="bg-background-100 rounded-lg p-6">
            <div className="w-12 h-12 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center text-xl mx-auto mb-3">
              <i className="ri-qq-line"></i>
            </div>
            <p className="text-xs text-foreground-500 mb-1">QQ客服</p>
            <p className="text-sm font-medium text-foreground-900">
              {contactData.qq}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}